import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { fetchCurrentUser } from "../../../store/userSlice";
import { useEffect } from "react";

const checkPermissions = (requiredPermissions, userPermissions) => {
  if (!userPermissions) return false;
  return requiredPermissions.every(permission =>
    userPermissions?.some(userPerm => userPerm.model_name === permission)
  );
};

const PrivateRoute = ({ userPermissions, requiredPermissions }) => {
  const userRole = useSelector(state => state.userReducer.userRole);
  const dispatch=useDispatch()
  let hasPermissions = checkPermissions(requiredPermissions, userPermissions);
  // console.log(requiredPermissions);
  hasPermissions = process.env.REACT_APP_ADMIN_ROLE === userRole || hasPermissions;
  useEffect(() => {
    dispatch(fetchCurrentUser())
  }, [])

  return hasPermissions && <Outlet /> ;
};

export default PrivateRoute;